




















import { Component, Vue, Prop } from 'vue-property-decorator'
import BoxTitle from './BoxTitle.vue'
import { goApply } from '@/apps/open/utils'

@Component({
  components: {
    BoxTitle
  }
})

export default class AccessProcess extends Vue {
  @Prop()
  process!: Array<object>

  @Prop()
  applyLink!: string

  @Prop()
  caseId!: String

  goApply () {
    goApply(this.applyLink)
  }

  jumpChargeStandard (url: string) {
    window.open(url)
  }
}
